import { AllPayRulesResponse, PayRuleDB, PayRule, OnePayRuleResponse } from './@types/PayRuleModel';

export class PayRuleRepository {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getPayRules(): Promise<PayRuleDB[]> {
        try {
            const response = await this.httpService.get<AllPayRulesResponse>('/pay_rules');
            return response.data
                .map((pay_rule) => ({ ...pay_rule, id: pay_rule.pay_rule_id }))
                .sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener las pay_rules:', error);
            throw error;
        }
    }
    async createPayRule(data: PayRule): Promise<PayRuleDB> {
        try {
            const response = await this.httpService.post<OnePayRuleResponse, PayRule>('/pay_rules', { data });
            return { ...response.data, id: response.data.pay_rule_id };
        } catch (error) {
            console.error('Error al crear el pay_rule:', error);
            throw error;
        }
    }
    async deletePayRule(id: number): Promise<number> {
        try {
            await this.httpService.delete<void>(`/pay_rules/${id}`);
            return id;
        } catch (error) {
            console.error('Error deletePayRule:', error);
            throw error;
        }
    }
    async updatePayRule(id: number, data: PayRule): Promise<PayRule> {
        try {
            const response = await this.httpService.patch<OnePayRuleResponse, PayRule>(`/pay_rules/${id}`, { data });
            return response.data;
        } catch (error) {
            console.error('Error al actualizar el pay_rule:', error);
            throw error;
        }
    }
    async getPayRuleById(id: number): Promise<PayRuleDB> {
        try {
            const response = await this.httpService.get<OnePayRuleResponse>(`/pay_rules/${id}`);
            return { ...response.data, id: response.data.pay_rule_id };
        } catch (error) {
            console.error('Error al obtener el pay_rule:', error);
            throw error;
        }
    }
}
